namespace GeniuzPOS.Purchase {
    export namespace PoPurInvoiceAppService {
        export const baseUrl = 'Purchase/PoPurInvoiceApp';

        export declare function Create(request: Serenity.SaveRequest<PoPurInvoiceAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoPurInvoiceAppRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoPurInvoiceAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetNextNumber(request: GetNextNumberRequest, onSuccess?: (response: GetNextNumberResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoPurInvoiceAppRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoPurInvoiceApp/Create",
            Update = "Purchase/PoPurInvoiceApp/Update",
            Delete = "Purchase/PoPurInvoiceApp/Delete",
            Retrieve = "Purchase/PoPurInvoiceApp/Retrieve",
            GetNextNumber = "Purchase/PoPurInvoiceApp/GetNextNumber",
            List = "Purchase/PoPurInvoiceApp/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetNextNumber', 
            'List'
        ].forEach(x => {
            (<any>PoPurInvoiceAppService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
